<form [formGroup]="shiftForm" class="shift-form">
  <p-card [header]="isEditMode ? 'Update Shift' : 'Create Shift'" class="p-card-shadow">

    <div class="formgrid grid mb-3">
      <div class="field col-12 flex justify-content-between align-items-center">
        <div>
          <button pButton type="button" [label]="isEditMode ? 'Update' : 'Save'" icon="pi pi-save"
            class="p-button-sm p-button-primary mr-2" (click)="onSubmit()">
          </button>

          <button pButton type="button" label="Cancel" icon="pi pi-times" class="p-button-sm p-button-danger"
            (click)="cancel()">
          </button>
        </div>
        <div>
          <label class="block label-required" style="font-weight: bold;">Required Field</label>
        </div>
      </div>
    </div>

    <div class="grid p-fluid">
      <div class="field col-12 md:col-4">
        <label for="shiftName" class="label-required text-left">Shift Name</label>
        <input pInputText placeholder="Enter shift name" formControlName="shiftName"
          [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.shiftName.errors}" />
      </div>

      <div class="field col-12 md:col-4">
        <label for="fromTime" class="label-required text-left">From Time</label>
        <p-calendar formControlName="fromTime" [timeOnly]="true" hourFormat="12" [showIcon]="true"
          [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.fromTime.errors}">
        </p-calendar>
      </div>

      <div class="field col-12 md:col-4">
        <label for="toTime" class="label-required text-left">To Time</label>
        <p-calendar formControlName="toTime" [timeOnly]="true" hourFormat="12" [showIcon]="true"
          [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.toTime.errors}">
        </p-calendar>
      </div>

      <div class="field col-12 md:col-6">
        <label class="text-left">Weekends are based on</label>
        <div class="flex mt-2">
          <p-radioButton name="weekends" value="location" formControlName="weekends" label="Location">
          </p-radioButton>
          <p-radioButton name="weekends" value="shift" formControlName="weekends" label="Shift" class="ml-4">
          </p-radioButton>
        </div>
      </div>
    </div>
  </p-card>
</form>

<p-toast></p-toast>